import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedin, setisLoggedin] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    // Load user from cookies
    const storedUser = Cookies.get("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setisLoggedin(true);
    }
    setLoading(false); // Mark as initialized
  }, []);

  const loginUser = (userData) => {
    setUser(userData);
    setisLoggedin(true);
    Cookies.set("user", JSON.stringify(userData), { expires: 1 / 24 });
  };

  const logout = () => {
    setUser(null);
    setisLoggedin(false);
    Cookies.remove("user");
  };

  const updateUser = (updatedUser) => {
    setUser((prevUser) => ({
      ...prevUser,
      ...updatedUser,
    }));
    Cookies.set("user", JSON.stringify({ ...user, ...updatedUser }), {
      expires: 1 / 24,
    });
  };

  return (
    <AuthContext.Provider
      value={{ user, loginUser, logout, isLoggedin, updateUser, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
